import { QueryClient } from "@tanstack/react-query";
import { createAppKit } from "@reown/appkit/react";
import { mainnet as appKitMainnet, sepolia as appKitSepolia, type AppKitNetwork } from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { createConfig, http, injected, type Config } from "wagmi";
import { mainnet as wagmiMainnet, sepolia as wagmiSepolia } from "wagmi/chains";
import { EXPECTED_CHAIN_ID, envString } from "../utils/config";

export const reownProjectId = envString("VITE_REOWN_PROJECT_ID") ?? "";
export const isReownConfigured = reownProjectId.length > 0;
export const queryClient = new QueryClient();

const appKitNetworks = [EXPECTED_CHAIN_ID === appKitSepolia.id ? appKitSepolia : appKitMainnet] as [AppKitNetwork, ...AppKitNetwork[]];
const wagmiChains = [EXPECTED_CHAIN_ID === wagmiSepolia.id ? wagmiSepolia : wagmiMainnet] as const;
const metadata = {
  name: "CODE APE Genesis",
  description: "AI-agent CODE APE minting and launch utility.",
  url: "https://code-ape.com",
  icons: ["https://code-ape.com/icon.svg"]
};

function createFallbackWagmiConfig(): Config {
  return createConfig({
    chains: wagmiChains,
    connectors: [injected()],
    transports: {
      [wagmiMainnet.id]: http(),
      [wagmiSepolia.id]: http()
    }
  });
}

function createReownWagmiConfig(): Config {
  const wagmiAdapter = new WagmiAdapter({
    networks: appKitNetworks,
    projectId: reownProjectId
  });

  createAppKit({
    adapters: [wagmiAdapter],
    networks: appKitNetworks,
    projectId: reownProjectId,
    metadata,
    features: {
      analytics: true,
      email: false,
      socials: false,
      swaps: false,
      onramp: false
    },
    themeMode: "dark",
    themeVariables: {
      "--w3m-accent": "#00ff41"
    }
  });

  return wagmiAdapter.wagmiConfig;
}

export const wagmiConfig = isReownConfigured ? createReownWagmiConfig() : createFallbackWagmiConfig();
